module.exports = __webpack_public_path__ + "static/media/ticker_icon_home.15f02882.svg";